const timeZoneList = [
  { name: '(UTC-12:00) Pacific/Wake', value: 'Pacific/Wake' },
  { name: '(UTC-11:00) Pacific/Apia', value: 'Pacific/Apia' },
  { name: '(UTC-10:00) Pacific/Honolulu', value: 'Pacific/Honolulu' },
  { name: '(UTC-09:00) America/Anchorage', value: 'America/Anchorage' },
  { name: '(UTC-08:00) America/Los_Angeles', value: 'America/Los_Angeles' },
  { name: '(UTC-07:00) America/Phoenix', value: 'America/Phoenix' },
  { name: '(UTC-07:00) America/Chihuahua', value: 'America/Chihuahua' },
  { name: '(UTC-07:00) America/Denver', value: 'America/Denver' },
  { name: '(UTC-06:00) America/Managua', value: 'America/Managua' },
  { name: '(UTC-06:00) America/Chicago', value: 'America/Chicago' },
  { name: '(UTC-06:00) America/Mexico_City', value: 'America/Mexico_City' },
  { name: '(UTC-06:00) America/Regina', value: 'America/Regina' },
  { name: '(UTC-05:00) America/Bogota', value: 'America/Bogota' },
  { name: '(UTC-05:00) America/New_York', value: 'America/New_York' },
  { name: '(UTC-05:00) America/Indiana/Indianapolis', value: 'America/Indiana/Indianapolis' },
  { name: '(UTC-05:00) America/Bogota', value: 'America/Bogota' },
  { name: '(UTC-04:00) America/Halifax', value: 'America/Halifax' },
  { name: '(UTC-04:00) America/Caracas', value: 'America/Caracas' },
  { name: '(UTC-04:00) America/Santiago', value: 'America/Santiago' },
  { name: '(UTC-03:30) America/St_Johns', value: 'America/St_Johns' },
  { name: '(UTC-03:00) America/Sao_Paulo', value: 'America/Sao_Paulo' },
  { name: '(UTC-03:00) America/Argentina/Buenos_Aires', value: 'America/Argentina/Buenos_Aires' },
  { name: '(UTC-03:00) America/Godthab', value: 'America/Godthab' },
  { name: '(UTC-02:00) America/Noronha', value: 'America/Noronha' },
  { name: '(UTC-01:00) Atlantic/Azores', value: 'Atlantic/Azores' },
  { name: '(UTC-01:00) Atlantic/Cape_Verde', value: 'Atlantic/Cape_Verde' },
  { name: '(UTC) Africa/Casablanca', value: 'Africa/Casablanca' },
  { name: '(UTC) Europe/London', value: 'Europe/London' },
  { name: 'UTC', value: 'UTC' },
  { name: '(UTC) Europe/London', value: 'Europe/London' },
  { name: '(UTC) Africa/Casablanca', value: 'Africa/Casablanca' },
  { name: '(UTC+01:00) Europe/Berlin', value: 'Europe/Berlin' },
  { name: '(UTC+01:00) Europe/Belgrade', value: 'Europe/Belgrade' },
  { name: '(UTC+01:00) Europe/Paris', value: 'Europe/Paris' },
  { name: '(UTC+01:00) Europe/Sarajevo', value: 'Europe/Sarajevo' },
  { name: '(UTC+01:00) Africa/Lagos', value: 'Africa/Lagos' },
  { name: '(UTC+02:00) Europe/Bucharest', value: 'Europe/Bucharest' },
  { name: '(UTC+02:00) Africa/Cairo', value: 'Africa/Cairo' },
  { name: '(UTC+02:00) Africa/Johannesburg', value: 'Africa/Johannesburg' },
  { name: '(UTC+02:00) Europe/Helsinki', value: 'Europe/Helsinki' },
  { name: '(UTC+02:00) Europe/Istanbul', value: 'Europe/Istanbul' },
  { name: '(UTC+02:00) Asia/Jerusalem', value: 'Asia/Jerusalem' },
  { name: '(UTC+02:00) Africa/Johannesburg', value: 'Africa/Johannesburg' },
  { name: '(UTC+03:00) Asia/Baghdad', value: 'Asia/Baghdad' },
  { name: '(UTC+03:00) Asia/Riyadh', value: 'Asia/Riyadh' },
  { name: '(UTC+03:00) Europe/Moscow', value: 'Europe/Moscow' },
  { name: '(UTC+03:00) Africa/Nairobi', value: 'Africa/Nairobi' },
  { name: '(UTC+03:00) Asia/Riyadh', value: 'Asia/Riyadh' },
  { name: '(UTC+03:00) Europe/Moscow', value: 'Europe/Moscow' },
  { name: '(UTC+03:30) Asia/Tehran', value: 'Asia/Tehran' },
  { name: '(UTC+04:00) Asia/Muscat', value: 'Asia/Muscat' },
  { name: '(UTC+04:00) Asia/Tbilisi', value: 'Asia/Tbilisi' },
  { name: '(UTC+04:30) Asia/Kabul', value: 'Asia/Kabul' },
  { name: '(UTC+05:00) Asia/Yekaterinburg', value: 'Asia/Yekaterinburg' },
  { name: '(UTC+05:00) Asia/Karachi', value: 'Asia/Karachi' },
  { name: '(UTC+05:30) Asia/Calcutta', value: 'Asia/Calcutta' },
  { name: '(UTC+05:45) Asia/Katmandu', value: 'Asia/Katmandu' },
  { name: '(UTC+06:00) Asia/Dhaka', value: 'Asia/Dhaka' },
  { name: '(UTC+06:00) Asia/Novosibirsk', value: 'Asia/Novosibirsk' },
  { name: '(UTC+06:00) Asia/Colombo', value: 'Asia/Colombo' },
  { name: '(UTC+06:30) Asia/Rangoon', value: 'Asia/Rangoon' },
  { name: '(UTC+07:00) Asia/Bangkok', value: 'Asia/Bangkok' },
  { name: '(UTC+07:00) Asia/Krasnoyarsk', value: 'Asia/Krasnoyarsk' },
  { name: '(UTC+08:00) Asia/Hong_Kong', value: 'Asia/Hong_Kong' },
  { name: '(UTC+08:00) Asia/Irkutsk', value: 'Asia/Irkutsk' },
  { name: '(UTC+08:00) Asia/Singapore', value: 'Asia/Singapore' },
  { name: '(UTC+08:00) Australia/Perth', value: 'Australia/Perth' },
  { name: '(UTC+08:00) Asia/Singapore', value: 'Asia/Singapore' },
  { name: '(UTC+08:00) Asia/Taipei', value: 'Asia/Taipei' },
  { name: '(UTC+08:00) Asia/Irkutsk', value: 'Asia/Irkutsk' },
  { name: '(UTC+08:00) Asia/Hong_Kong', value: 'Asia/Hong_Kong' },
  { name: '(UTC+09:00) Asia/Seoul', value: 'Asia/Seoul' },
  { name: '(UTC+09:00) Asia/Tokyo', value: 'Asia/Tokyo' },
  { name: '(UTC+09:00) Asia/Yakutsk', value: 'Asia/Yakutsk' },
  { name: '(UTC+09:30) Australia/Adelaide', value: 'Australia/Adelaide' },
  { name: '(UTC+09:30) Australia/Darwin', value: 'Australia/Darwin' },
  { name: '(UTC+10:00) Australia/Brisbane', value: 'Australia/Brisbane' },
  { name: '(UTC+10:00) Australia/Sydney', value: 'Australia/Sydney' },
  { name: '(UTC+10:00) Australia/Hobart', value: 'Australia/Hobart' },
  { name: '(UTC+10:00) Pacific/Guam', value: 'Pacific/Guam' },
  { name: '(UTC+10:00) Asia/Vladivostok', value: 'Asia/Vladivostok' },
  { name: '(UTC+11:00) Asia/Magadan', value: 'Asia/Magadan' },
  { name: '(UTC+12:00) Pacific/Auckland', value: 'Pacific/Auckland' },
  { name: '(UTC+12:00) Pacific/Fiji', value: 'Pacific/Fiji' },
  { name: '(UTC+13:00) Pacific/Tongatapu', value: 'Pacific/Tongatapu' },
];

export default timeZoneList;
